import React from "react";

export default class ExamLevelChartComponent extends React.PureComponent<{ chartData?: { title: string, data: { title: string, value: number }[] }[] }, {}> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.setData();
    }

    setData() {
        let Highcharts = require('highcharts');
        let categories = this.props.chartData ? this.props.chartData[0].data.map(({ title }) => title) : []

        var series = this.props.chartData ?
            this.props.chartData.map((item) => {
                return {
                    data: item.data.map(({ value }) => value),
                    name: item.title,
                    showInLegend: true
                }
            }) : []

        let json = {
            chart: {
                type: 'spline',
                spacingLeft: 10,
                spacingRight: 10,
                height: 300,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                style: {
                    fontFamily: 'Dana-Fanum',
                    fontWeight: 1
                }
            },
            legend: {
                symbolHeight: 10,
                symbolWidth: 10,
                symbolRadius: 0,
                itemDistance: 4,
                align: 'center',
                itemStyle: {
                    fontSize: '10px',
                    color: '#172b4d',
                    fontWeight: 400,
                },
            },
            plotOptions: {
                enabled: {},
                series: {
                    marker: {
                        enabled: false,
                    },
                },
            },
            tooltip: {
                useHTML: true,
                pointFormat: '{series.name}<br/>{point.time}<br>%{point.percentage:.1f}'
            },
            title: false,
            yAxis: {
                title: false,
                gridLineDashStyle: 'dash',
                gridLineWidth: 1,
                gridLineColor: '#DFE3E8',
                tickmarkPlacement: 'inside',
                startOnTick: true,
                endOnTick: true,
            },
            xAxis: {
                categories: categories,
            },
            series: series
        };


        Highcharts.chart('container', json);
    }

    render(): React.ReactNode {
        return (<>
            <div id="container"></div>
        </>);
    }
}